/**
 * CandidateBundle lazy route wrappers (positions.tsx convention).
 *
 * RR v7 `lazy` route property cannot return `element`/`children` for a
 * layout-with-children subtree (divergence #3) — so the page components are
 * React.lazy-wrapped here and mounted via <Suspense> in App.tsx, exactly like
 * the Plan 02-06/07 route wrappers. react-markdown (consent page) stays in its
 * own chunk because only the lazy CandidateConsentPage imports it.
 */
import { lazy } from "react";

const CandidateConsentPage = lazy(() =>
  import("@/features/candidate/CandidateConsentPage").then((m) => ({
    default: m.CandidateConsentPage,
  })),
);

const CandidatePersonalInfoPage = lazy(() =>
  import("@/features/candidate/CandidatePersonalInfoPage").then((m) => ({
    default: m.CandidatePersonalInfoPage,
  })),
);

// Plan 03-06 — Stage 1 question loop + one-way confirmation (same lazy convention).
const Stage1QuestionPage = lazy(() =>
  import("@/features/candidate/Stage1QuestionPage").then((m) => ({
    default: m.Stage1QuestionPage,
  })),
);

const CandidateConfirmationPage = lazy(() =>
  import("@/features/candidate/CandidateConfirmationPage").then((m) => ({
    default: m.CandidateConfirmationPage,
  })),
);

export function CandidateConsentRoute() {
  return <CandidateConsentPage />;
}

export function CandidatePersonalInfoRoute() {
  return <CandidatePersonalInfoPage />;
}

export function Stage1QuestionRoute() {
  return <Stage1QuestionPage />;
}

export function CandidateConfirmationRoute() {
  return <CandidateConfirmationPage />;
}
